import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import cropStorageImage from 'rebook/apps/utils/urls/cropStorageImage';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import truncateChars from 'rebook/apps/utils/text/truncateChars';
import {
  BOOKS_BOOK_CITATION_SET_DATA,
  BOOKS_BOOK_CITATION_RESET_DATA,
} from 'rebook/apps/books/constants';
import { Citation } from 'rebook/apps/books/models';


export function fetchInitialData(match, location = {}) {
  return async(dispatch, getState) => {
    const currentState = getState().bookCitation;
    let newState = {};
    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
      };
    }
    if (currentState.citation) {
      newState = {
        ...newState,
        ...currentState,
      };
    }

    // set partial state (it could probably be the data obtained from router)
    dispatch(setData(newState));

    if (!newState.citation) {
      await dispatch(fetchCitation(match));
    }
  };
}

export function fetchCitation(match) {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const { citationId } = match.params;
    const url = `/api/citations/${citationId}/`;
    return await fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(
        ({ data }) => {
          dispatch(setData({ citation: data }));
        }
      )
      .catch(
        ({ data, resp, error }) => {
          if (resp.status === 404) {
            dispatch(Error404Actions.show());
          }
          else {
            Raven.captureMessage('failed to load citation due to server error', {
              level: 'error',
              extra: {
                status: resp.status,
                response: data,
                error,
              },
            });
            throw new Error('failed to load citation due to server error');
          }
        }
      );
  };
}

function setSeoMeta() {
  return (dispatch, getState) => {
    const { bookCitation } = getState();
    const { citation } = bookCitation;
    const theCitation = citation && new Citation(citation);
    const desktopUrl = `https://${BASE_HOST}${theCitation.getUrl()}`;
    const cover200x300 = cropStorageImage(citation.book.default_cover, 200, 300);
    const title = `Цитата номер ${citation.id} из книги 📚 ` +
        `${citation.book.main_author
          ? `${citation.book.main_author.genitive_full_name || citation.book.main_author.cover_name}`
          : '' } ` +
        `«${citation.book.name}» — MyBook`;
    const description = `Цитата номер ${citation.id} из книги «${citation.book.name}» - «` +
      truncateChars(citation.text ? citation.text : '', 100) + '»';
    const ogTitle = title;
    const ogDescription = description;
    const ogTags = [
      { name: 'type', value: 'books.book' },
      { name: 'image', value: cover200x300 },
      { name: 'title', value: ogTitle },
      { name: 'description', value: ogDescription },
      { name: 'url', value: desktopUrl },
    ];
    const ogTwitterTags = [
      { name: 'title', value: ogTitle },
      { name: 'description', value: ogDescription },
      { name: 'image', value: cover200x300 },
    ];
    let ogBookTags = [];
    if (citation.book.ean) {
      ogBookTags.push({
        name: 'isbn',
        value: citation.book.ean,
      });
    }
    if (citation.book.main_author) {
      ogBookTags.push({
        name: 'author',
        value: `https://${BASE_HOST}${citation.book.main_author.absolute_url}`,
      });
    }
    dispatch(SeoActions.setData({
      imageSrc: cover200x300,
      canonicalUrl: desktopUrl,
      title,
      description,
      ogTags,
      ogBookTags,
      ogTwitterTags,
    }));
  };
}

export function setData(payload) {
  return (dispatch) => {
    const { citation } = payload;
    dispatch({
      type: BOOKS_BOOK_CITATION_SET_DATA,
      payload,
    });
    if (citation) {
      dispatch(setSeoMeta());
    }
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: BOOKS_BOOK_CITATION_RESET_DATA,
    });
  };
}
